import React from 'react';
import history from 'app/routes/history';
import { parseAmount } from 'app/utils/parsers';
import { Progress, Card, CardBody } from 'reactstrap';

interface IPaymentSummaryProps {
  payment: any;
  selectPayment: any;
}
export default class PaymentSummary extends React.Component<
  IPaymentSummaryProps
> {
  static defaultProps = {
    payment: undefined,
    selectPayment: undefined,
  };

  onClick = () => {
    this.props.selectPayment(this.props.payment.id);
    history.push(`/payments/${this.props.payment.id}`);
  };

  renderOutOfText(): React.ReactNode {
    const outOfText = `${parseAmount(
      this.props.payment.collectedAmount,
    )} out of ${parseAmount(
      this.props.payment.totalAmount,
    )}`;

    if (this.props.payment.collected === 0) {
      return <span className="none-collected">{outOfText}</span>;
    }
    return outOfText;
  }

  render(): React.ReactNode {
    const progressPercentage = this.props.payment.collected === 0
      ? 0
      : (this.props.payment.collectedAmount / this.props.payment.totalAmount) * 100;

    return (
      <Card>
        <CardBody>
          <div className="row">
            <div className="col text-weight-medium">Summary</div>
          </div>
          <div className="row with-margin-top">
            <div className="col">
              <Progress multi>
                <Progress bar color="green" value={progressPercentage}>
                  {/* <span>
                    {parseAmount(
                      this.props.payment.collected * this.props.payment.amount,
                    )}
                  </span> */}
                </Progress>
                <Progress bar color="grey" value={100 - progressPercentage}>
                  {/* {parseAmount(
                    this.props.payment.total * this.props.payment.amount,
                  )} */}
                </Progress>
                {/* {this.renderOutOfText()} */}
              </Progress>
            </div>
          </div>
          <div className="row with-margin-top-10">
            <div className="col text-left normal-text">
              {parseAmount(
                this.props.payment.collectedAmount,
              )}
            </div>
            <div className="col text-right normal-text">
              {parseAmount(
                this.props.payment.totalAmount,
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }
}
